/**
 * Wishlist (Merkliste) – übernimmt das Look & Feel der Auktionen.
 * Beobachtet #wishlist-hero-shared-list-view und injiziert unsere Klassen.
 */
let wishlistObserver = null;
let wishlistObserverTimeout = null;
let wishlistInitDone = false;

function getWishlistRoot() {
  return document.getElementById('wishlist-hero-shared-list-view');
}

function addWishlistHeaderClasses(rootEl) {
  const header = rootEl.querySelector('.wishlist-hero-page-header');
  if (header) {
    header.classList.add('custom-wishlist-header');
  }

  const actionsBar = rootEl.querySelector('.wishlist-hero-page-actions-bar');
  if (actionsBar) {
    actionsBar.classList.add('custom-wishlist-actions-bar');
  }

  const emptyState = rootEl.querySelector('.wishlist-hero-list-no-items-content');
  if (emptyState) {
    emptyState.classList.add('custom-wishlist-empty');
  }
}

function findWishlistGrid(rootEl) {
  const candidates = rootEl.querySelectorAll('[class*="MuiGrid"], [class*="wishlist"]');
  for (const candidate of candidates) {
    if (candidate.querySelector('a[href*="/products/"]')) {
      return candidate;
    }
  }
  return null;
}

function addWishlistImageClasses(cardEl, linkEl) {
  const image = linkEl ? linkEl.querySelector('img') : null;
  if (linkEl) {
    linkEl.classList.add('collection-custom-auction-inner-box', 'custom-wishlist-image-box');
  }
  if (image) {
    image.classList.add('_a-grid-img');
    const imageWrapper = image.parentElement;
    if (imageWrapper) {
      imageWrapper.classList.add('_a-grid-card-img');
    }
  }
}

function findWishlistDetail(cardEl, linkEl) {
  if (!cardEl) return null;
  const afterLink = linkEl ? linkEl.nextElementSibling : null;
  if (afterLink) return afterLink;

  return (
    cardEl.querySelector('[class*="CardContent"]') ||
    cardEl.querySelector('[class*="MuiCardContent"]') ||
    cardEl.querySelector('[class*="wishlist-hero"]') ||
    cardEl.querySelector('[class*="MuiGrid-root"]')
  );
}

function pickWishlistTitle(detailEl) {
  if (!detailEl) return null;
  return (
    detailEl.querySelector('h2, h3, h4, h5, h6') ||
    detailEl.querySelector('[class*="Typography-h6"]') ||
    detailEl.querySelector('[class*="Typography-h5"]')
  );
}

function pickWishlistPrice(detailEl) {
  if (!detailEl) return null;
  const priceCandidates = Array.from(detailEl.querySelectorAll('span, p, div')).filter((el) =>
    /CHF|€|\$|\d+[\.,]\d{2}/.test(el.textContent || '')
  );
  return priceCandidates[0] || null;
}

function classifyWishlistButtons(btn) {
  const text = (btn.textContent || '').toLowerCase();
  const hasTrash =
    btn.querySelector('svg')?.getAttribute('data-icon') === 'trash' ||
    btn.getAttribute('aria-label')?.toLowerCase().includes('entfern') ||
    text.includes('entfern') ||
    text.includes('löschen') ||
    text.includes('delete');

  if (hasTrash) {
    btn.classList.add('custom-wishlist-btn-remove');
  } else if (text.includes('warenkorb') || text.includes('add')) {
    btn.classList.add('custom-wishlist-btn-add');
  } else {
    // Fallback by position: if no class set later, first is add, second is remove.
    btn.classList.add('custom-wishlist-btn-unknown');
  }
}

function ensureWishlistActionWrapper(cardEl, buttons) {
  if (!buttons || buttons.length === 0) return;

  let actionWrap = cardEl.querySelector('.custom-wishlist-actions');
  if (!actionWrap) {
    actionWrap = document.createElement('div');
    actionWrap.classList.add('custom-wishlist-actions');
    cardEl.appendChild(actionWrap);
  }

  buttons.forEach((btn) => {
    // Entferne aus bisherigem Grid-Wrapper, damit keine 25% Breiten mehr wirken.
    if (btn.parentElement !== actionWrap) {
      btn.parentElement?.removeChild(btn);
      actionWrap.appendChild(btn);
    }
    btn.classList.add('custom-wishlist-button');
    // Setze Breite auch inline, um evtl. inline-styles zu überstimmen.
    btn.style.width = '100%';
    btn.style.maxWidth = '100%';

    classifyWishlistButtons(btn);
  });

  // Fallback Zuordnung per Position, falls weder Text noch Icon gematcht haben.
  const unknowns = actionWrap.querySelectorAll('.custom-wishlist-btn-unknown');
  unknowns.forEach((btn, idx) => {
    if (!btn.classList.contains('custom-wishlist-btn-add') && !btn.classList.contains('custom-wishlist-btn-remove')) {
      if (idx === 0) {
        btn.classList.add('custom-wishlist-btn-add');
      } else {
        btn.classList.add('custom-wishlist-btn-remove');
      }
      btn.classList.remove('custom-wishlist-btn-unknown');
    }
  });

  // Falls dennoch beide Buttons als Add markiert wurden, korrigiere positionsbasiert.
  const actions = Array.from(actionWrap.querySelectorAll('button'));
  if (actions.length >= 2) {
    actions.forEach((btn, idx) => {
      btn.classList.remove('custom-wishlist-btn-add', 'custom-wishlist-btn-remove', 'custom-wishlist-btn-unknown');
      if (idx === 0) {
        btn.classList.add('custom-wishlist-btn-add');
      } else {
        btn.classList.add('custom-wishlist-btn-remove');
      }
    });
  }
}

function addWishlistCardClasses(cardEl) {
  if (!cardEl || cardEl.dataset.wishlistStyled === 'true') return;

  const productLink = cardEl.querySelector('a[href*="/products/"]');
  if (!productLink) return;

  cardEl.classList.add('collection-custom-auction-card', 'custom-wishlist-card');

  const detail = findWishlistDetail(cardEl, productLink);
  if (detail) {
    detail.classList.add('custom-wishlist-detail');
  }

  const titleEl = pickWishlistTitle(detail || cardEl);
  if (titleEl) {
    titleEl.classList.add('collection-custom-auction-title', 'custom-wishlist-title');
  }

  const priceEl = pickWishlistPrice(detail || cardEl);
  if (priceEl) {
    priceEl.classList.add('collection-custom-auction-price', 'custom-wishlist-price');
  }

  const buttons = Array.from(cardEl.querySelectorAll('button'));
  buttons.forEach((btn) => {
    btn.classList.add(
      'button',
      'button--outline',
      'button--regular',
      'button--fullwidth',
      'button--loader'
    );
  });
  ensureWishlistActionWrapper(cardEl, buttons);

  cardEl.dataset.wishlistStyled = 'true';
}

function applyWishlistLayout() {
  const rootEl = getWishlistRoot();
  if (!rootEl) return;

  rootEl.classList.add('custom-wishlist-root');
  addWishlistHeaderClasses(rootEl);

  const grid = findWishlistGrid(rootEl);
  if (!grid) return;

  grid.classList.add('custom-wishlist-grid');

  const cards = grid.querySelectorAll('[class*="MuiGrid-item"], [data-wishlist-item]');
  cards.forEach((card) => {
    addWishlistCardClasses(card);
  });
}

function initWishlistView() {
  const rootEl = getWishlistRoot();
  if (!rootEl) return;

  applyWishlistLayout();

  if (wishlistObserver) wishlistObserver.disconnect();
  wishlistObserver = new MutationObserver(() => {
    clearTimeout(wishlistObserverTimeout);
    wishlistObserverTimeout = setTimeout(applyWishlistLayout, 60);
  });

  wishlistObserver.observe(rootEl, { childList: true, subtree: true });
}

function tryInitWishlist() {
  if (wishlistInitDone) return true;
  const rootEl = getWishlistRoot();
  if (!rootEl) return false;
  wishlistInitDone = true;
  initWishlistView();
  // Footer-Buttons ebenfalls mit unseren Button-Klassen ausstatten.
  const footerButtons = document.querySelectorAll('.wishlist-hero-list-footer button');
  footerButtons.forEach((btn) => {
    btn.classList.add('button', 'button--outline', 'button--regular', 'button--fullwidth', 'button--loader', 'custom-wishlist-button');
  });
  return true;
}

function bootstrapWishlist() {
  // Direkt versuchen (falls Script nach DOMContentLoaded geladen wird).
  if (tryInitWishlist()) return;

  // Sobald DOM bereit ist erneut probieren.
  document.addEventListener('DOMContentLoaded', tryInitWishlist);
  if (document.readyState !== 'loading') {
    tryInitWishlist();
  }

  // Fallback: Beobachte DOM kurz, falls der Root erst später auftaucht.
  const fallbackObserver = new MutationObserver(() => {
    if (tryInitWishlist()) {
      fallbackObserver.disconnect();
    }
  });
  fallbackObserver.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => fallbackObserver.disconnect(), 7000);
}

bootstrapWishlist();
